<ng-container>
    <div class="menu" *ngIf="menu$ | async as menu">
        <a class="menu__heading" [routerLink]="menu.url">{{ menu.name }}</a>

        <ul class="menu__list">
            <knowledge-bank-menu-item *ngFor="let child of menu.children" [item]="child"></knowledge-bank-menu-item>
        </ul>
    </div>
</ng-container>
